import { DeereCachedFetch } from '../shared/fetch';
import proposalCodes from '../shared/codes/proposal.json';
import thirdPartyCodes from '../shared/codes/third-party.json';

let friendlyProposalStatusesMap = null;
let friendlyThirdPartyStatusesMap = null;
let friendlyProposalStatusesList = null;
let friendlyThirdPartyStatusesList = null;
export class StatusService {
    static get statuses() {
        return DeereCachedFetch('/api/statuses', {
            cacheDuration: 'forever'
        });
    }

    static get proposalStatuses() {
        return DeereCachedFetch('/api/quotes/statuses', {
            cacheDuration: 'forever'
        });
    }

    static get thirdPartyStatuses() {
        return DeereCachedFetch('/api/third-parties/statuses', {
            cacheDuration: 'forever'
        });
    }

    static getFriendlyProposalMessage(statusID) {
        return proposalCodes[statusID];
    }

    static getFriendlyThirdPartyMessage(statusID) {
        return thirdPartyCodes[statusID];
    }

    static get friendlyProposalStatusesMap() {
        if (!friendlyProposalStatusesMap) {
            friendlyProposalStatusesMap = (async () => {
                const statuses = await this.proposalStatuses;

                return Object.values(statuses).reduce((output, code) => {
                    output[code] = this.getFriendlyProposalMessage(code);
                    return output;
                }, {})
            })();
        }

        return friendlyProposalStatusesMap;
    }

    static get friendlyProposalStatusesList() {
        if (!friendlyProposalStatusesList) {
            friendlyProposalStatusesList = (async () => {
                const statuses = await this.proposalStatuses;

                return Object.values(statuses).map((code) => ({
                    label: this.getFriendlyProposalMessage(code),
                    value: code
                })).filter(({ label }) => !!label);
            })();
        }

        return friendlyProposalStatusesList;
    }

    static get friendlyThirdPartyStatusesMap() {
        if (!friendlyThirdPartyStatusesMap) {
            friendlyThirdPartyStatusesMap = (async () => {
                const statuses = await this.thirdPartyStatuses;

                return Object.values(statuses).reduce((output, code) => {
                    output[code] = this.getFriendlyThirdPartyMessage(code);
                    return output;
                }, {})
            })();
        }

        return friendlyThirdPartyStatusesMap;
    }

    static get friendlyThirdPartyStatusesList() {
        if (!friendlyThirdPartyStatusesList) {
            friendlyThirdPartyStatusesList = (async () => {
                const statuses = await this.thirdPartyStatuses;

                return Object.values(statuses).map((code) => ({
                    label: this.getFriendlyThirdPartyMessage(code),
                    value: code
                })).filter(({ label }) => !!label);
            })();
        }

        return friendlyThirdPartyStatusesList;
    }

    static color(code) {
        if (this.isSuccess(code)) {
            return '#367C2B';
        } else if (this.isInProgress(code)) {
            return '#FFC107';
        }

        return '#f44336';
    }

    static status(code) {
        if (this.isSuccess(code)) {
            return 'success';
        } else if (this.isInProgress(code)) {
            return 'in-progress';
        }

        return 'error';
    }

    static isSuccess(code) {
        return [1, 2, 5, 7, 9].includes(code);
    }

    static isInProgress(code) {
        return [3, 11].includes(code);
    }

    static isError(code) {
        return !this.isSuccess(code) && !this.isInProgress(code);
    }
}
